"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _action = require("../../notification/action");

var _action2 = require("../../spinner-overlay/action");

var _notificationMediumService = require("../../../services/notification-medium-service");

var _policyAdminService = require("../../../services/policy-admin-service");

var _commonConstants = require("../../../utils/common-constants");

var _actions = require("./actions");

var _constants = require("./constants");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(addPolicyWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(addPolicyWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(notificationMediumListWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(notificationMediumListWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(profileSettingsWatcher),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(profileSettingsWorker);

function addPolicyWatcher() {
  return regeneratorRuntime.wrap(function addPolicyWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.AddPolicyType.POLICY_CREATE_REQUEST, addPolicyWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function addPolicyWorker(action) {
  var _action$payload, history, data, consumer, consumerEntityId, redirectPath, response, _e$response, _e$response$data, reason;

  return regeneratorRuntime.wrap(function addPolicyWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, history = _action$payload.history, data = _action$payload.data, consumer = _action$payload.consumer, consumerEntityId = _action$payload.consumerEntityId, redirectPath = _action$payload.redirectPath;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.put)((0, _actions.createPolicyLoading)());

        case 4:
          _context2.next = 6;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: true,
            size: 'medium',
            message: _constants.translatedStrings.addingPolicy
          }));

        case 6:
          _context2.next = 8;
          return (0, _effects.call)(_policyAdminService.createPolicy, {
            data: data,
            consumer: consumer,
            consumerEntityId: consumerEntityId
          });

        case 8:
          response = _context2.sent;
          _context2.next = 11;
          return (0, _effects.put)((0, _actions.createPolicySuccess)(response));

        case 11:
          _context2.next = 13;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 13:
          history.push({
            pathname: redirectPath,
            notification: {
              title: _constants.translatedStrings.policyCreatedSuccessMessage,
              type: _commonConstants.successNotificationType,
              time: 'normal'
            }
          });
          _context2.next = 23;
          break;

        case 16:
          _context2.prev = 16;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 20;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 20:
          reason = ((_e$response = _context2.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.message) || '';
          _context2.next = 23;
          return (0, _effects.put)((0, _actions.createPolicyFailure)(reason));

        case 23:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 16]]);
}

function notificationMediumListWatcher() {
  return regeneratorRuntime.wrap(function notificationMediumListWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.approvalNotificationMediumListType.APPROVAL_NOTIFICATION_MEDIUM_LIST_REQUEST, notificationMediumListWorker);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function notificationMediumListWorker() {
  var data, _response$data, response, reason;

  return regeneratorRuntime.wrap(function notificationMediumListWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.put)((0, _actions.approvalNotificationMediumListLoading)());

        case 3:
          _context4.next = 5;
          return (0, _effects.call)(_notificationMediumService.fetchNotificationMediumList);

        case 5:
          data = _context4.sent;
          _context4.next = 8;
          return (0, _effects.put)((0, _actions.approvalNotificationMediumListSuccess)((data === null || data === void 0 ? void 0 : data.result) || []));

        case 8:
          _context4.next = 18;
          break;

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](0);
          response = _context4.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context4.next = 16;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 16:
          _context4.next = 18;
          return (0, _effects.put)((0, _actions.approvalNotificationMediumListFail)(reason));

        case 18:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 10]]);
}

function profileSettingsWatcher() {
  return regeneratorRuntime.wrap(function profileSettingsWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.ProfileSettingsType.PROFILE_SETINGS_REQUEST, profileSettingsWorker);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function profileSettingsWorker(action) {
  var response, _e$response2, _e$response2$data, reason;

  return regeneratorRuntime.wrap(function profileSettingsWorker$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: true,
            size: 'medium',
            message: _constants.translatedStrings.addingPolicy
          }));

        case 2:
          _context6.prev = 2;
          _context6.next = 5;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium',
            message: 'Loading...'
          }));

        case 5:
          _context6.next = 7;
          return (0, _effects.call)(_policyAdminService.getProfileSettings, action.payload);

        case 7:
          response = _context6.sent;
          _context6.next = 10;
          return (0, _effects.put)((0, _actions.profileSettingsSuccess)(response));

        case 10:
          _context6.next = 21;
          break;

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          reason = ((_e$response2 = _context6.t0.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.message) || '';
          _context6.next = 17;
          return (0, _effects.put)((0, _actions.profileSettingsFailure)(reason));

        case 17:
          _context6.next = 19;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 19:
          _context6.next = 21;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 21:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[2, 12]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(addPolicyWatcher), (0, _effects.fork)(notificationMediumListWatcher), (0, _effects.fork)(profileSettingsWatcher)]);

exports.default = _default;